export const LOGIN_REQUEST = 'auth/login-request';
export const LOGIN_SUCCESS = 'auth/login-success';
export const LOGIN_FAILURE = 'auth/login-failure';
export const LOGIN_MFA = 'auth/login-mfa';

export const FETCH_ME_REQUEST = 'auth/fetch-me-request';
export const FETCH_ME_SUCCESS = 'auth/fetch-me-success';
export const FETCH_ME_FAILURE = 'auth/fetch-me-failure';

export const FETCH_THIRD_PARTY_SSO_URL_REQUEST =
  'auth/fetch-third-party-sso-url-request';
export const FETCH_THIRD_PARTY_SSO_URL_SUCCESS =
  'auth/fetch-third-party-sso-url-success';
export const FETCH_THIRD_PARTY_SSO_URL_FAILURE =
  'auth/fetch-third-party-sso-url-failure';

export const LOGOUT_REQUEST = 'auth/logout-request';
export const LOGOUT_SUCCESS = 'auth/logout-success';
export const LOGOUT_FAILURE = 'auth/logout-failure';

export const RESET_PASSWORD_EMAIL_REQUEST =
  'auth/forgot-password-email-request';
export const RESET_PASSWORD_EMAIL_SUCCESS =
  'auth/forgot-password-email-success';
export const RESET_PASSWORD_EMAIL_FAILURE =
  'auth/forgot-password-email-failure';

export const LOGIN = 'LOGIN';
export const PASSWORD_RESET = 'PASSWORD_RESET';
export const PASSWORD_CONFIRM = 'PASSWORD_CONFIRM';
export const SIGN_UP = 'SIGN_UP';
export const ACTIVATE = 'ACTIVATE';

export const UPDATE_CURRENT_USER_PICTURE = 'auth/update-current-user-picture';

export const SET_THIRD_PARTY_SSO = 'auth/set-is-third-party-sso';
export const REFRESH_TOKEN = 'auth/refresh-token';

export const UPDATE_CURRENT_USER_PREFERENCES_REQUEST =
  'auth/update-current-user-preferences-request';
export const UPDATE_CURRENT_USER_PREFERENCES_SUCCESS =
  'auth/update-current-user-preferences-success';
export const UPDATE_CURRENT_USER_PREFERENCES_FAILURE =
  'auth/update-current-user-preferences-failure';